(ns teamoesterreich.admin-mode.detail-filter.detail-filter-form
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [reagent.core :as r]
            [teamoesterreich.admin-mode.detail-filter.text-search :as text-search]
            [teamoesterreich.admin-mode.detail-filter.destination-filter :as destination-filter]
            [teamoesterreich.admin-mode.detail-filter.member-filter :as member-filter]
            [teamoesterreich.admin-mode.detail-filter.person-filter :as person-filter]
            [teamoesterreich.admin-mode.detail-filter.education-filter :as education-filter]
            [teamoesterreich.admin-mode.detail-filter.licence-filter :as licence-filter]
            [teamoesterreich.admin-mode.detail-filter.device-filter :as device-filter]

            [teamoesterreich.admin-mode.detail-filter.tafel-filter :as tafel-filter]
            [teamoesterreich.admin-mode.detail-filter.wanado-filter :as wanado-filter]
            [teamoesterreich.admin-mode.detail-filter.cat-filter :as cat-filter]
            [teamoesterreich.admin-mode.detail-filter.nocat-filter :as nocat-filter]
            [teamoesterreich.admin-mode.detail-filter.online-filter :as online-filter]
            [teamoesterreich.admin-mode.detail-filter.neighbor-filter :as neighbor-filter]
            [teamoesterreich.admin-mode.detail-filter.lebensretter-filter :as lebensretter-filter]
            [teamoesterreich.admin-mode.detail-filter.canYou-filter :as canYou-filter]
            [teamoesterreich.util.log :as log]))



(defn wait-do-check [!waiting? !loaded? event-fn]
  (fn [e val]
    (js/console.log "wait or do" val)
    (event-fn val)
    (reset! !waiting? false)
    (when-not val (reset! !loaded? false))))


(defn get-filter-request-part-noAddFields [!search !filter]
  {:srch                                @!search
   :has-device                          (:has-device @!filter)
   :filter-zip                          (:filter-zip @!filter)
   :filter-status                       (:filter-status @!filter)
   :filter-organizationDepartment       (:filter-organizationDepartment @!filter)
   :filter-organization                 (:filter-organization @!filter)
   :filter-degree                       (:filter-degree @!filter)
   :filter-job-status                   (:filter-job-status @!filter)
   :filter-language                     (:filter-language @!filter)
   :filter-nationality                  (:filter-nationality @!filter)
   :filter-age-min                      (:filter-age @!filter)
   :filter-age-max                      (:filter-age-max @!filter)

   :filter-lebensretter                 (:filter-lebensretter @!filter)
   :filter-lebensretterActive           (:filter-lebensretterActive @!filter)
   :filter-firstResponderActive         (:filter-firstResponderActive @!filter)
   :filter-lr-clearance-from            (:filter-lr-clearance-from @!filter)
   :filter-lr-clearance-to              (:filter-lr-clearance-to @!filter)
   :filter-lrSource                     (:filter-lrSource @!filter)
   :filter-lebensretterHasInterventions (:filter-lebensretterHasInterventions @!filter)
   :filter-lr-qualification-type        (:filter-lr-qualification-type @!filter)
   :lr-clearanceFrom                    (:lr-clearanceFrom @!filter)
   :lr-clearanceTo                      (:lr-clearanceTo @!filter)

   :filter-canYou                       (:filter-canYou @!filter)
   :filter-canYouAnswer                 (:filter-canYouAnswer @!filter)


   :filter-isRk                         (:filter-isRk @!filter)
   :filter-toe-active                   (:filter-toe-active @!filter)
   :identity-todo                       (:identity-todo @!filter)
   :orgId-todo                          (:orgId-todo @!filter)
   :delete-request-todo                 (:delete-request-todo @!filter)
   :add-filter                          (merge {}
                                               (:add-filter-licence @!filter)
                                               (:add-filter-wanado @!filter)
                                               (:add-filter-nocat @!filter)
                                               (:add-filter-online @!filter)
                                               (:add-filter-cat @!filter)
                                               (:add-filter-neighbor @!filter)
                                               )
   :wanado                              (:add-filter-wanado @!filter)
   }
  )
(defn get-filter-request-part [search searchAddFields filter]
  {:srch                                search
   :srch-add-fields                     searchAddFields
   :has-device                          (:has-device filter)
   :has-lrDevice                        (:has-lrDevice filter)
   :filter-zip                          (:filter-zip filter)
   :filter-status                       (:filter-status filter)
   :filter-organizationMain             (:filter-organizationMain filter)
   :filter-organizationDepartment       (:filter-organizationDepartment filter)
   :filter-organization                 (:filter-organization filter)
   :filter-degree                       (:filter-degree filter)
   :filter-job-status                   (:filter-job-status filter)
   :filter-language                     (:filter-language filter)
   :filter-nationality                  (:filter-nationality filter)
   :filter-age-min                      (:filter-age filter)
   :filter-age-max                      (:filter-age-max filter)


   :filter-since-from                   (:filter-since-from filter)
   :filter-since-to                     (:filter-since-to filter)

   :filter-lebensretter                 (:filter-lebensretter filter)
   :filter-lebensretterActive           (:filter-lebensretterActive filter)
   :filter-firstResponderActive         (:filter-firstResponderActive filter)
   :filter-lr-clearance-from            (:filter-lr-clearance-from filter)
   :filter-lr-clearance-to              (:filter-lr-clearance-to filter)
   :filter-lrSince-from                 (:filter-lrSince-from filter)
   :filter-lrSince-to                   (:filter-lrSince-to filter)
   :filter-lrSource                     (:filter-lrSource filter)
   :filter-lebensretterHasInterventions (:filter-lebensretterHasInterventions filter)
   :filter-lr-qualification-type        (:filter-lr-qualification-type filter)
   :lr-clearanceFrom                    (:lr-clearanceFrom filter)
   :lr-clearanceTo                      (:lr-clearanceTo filter)

   :filter-canYou                       (:filter-canYou filter)
   :filter-canYouAnswer                 (:filter-canYouAnswer filter)

   :member-detail                       (when (:add-filter-member-show filter)
                                          (merge {:show true}
                                                 (when-let [f (:filter-isAdmin filter)] [:filter-isAdmin f])
                                                 (when-let [f (:filter-profileInvalid filter)] [:filter-profileInvalid f])
                                                 (when-let [f (:filter-identityInvalid filter)] [:filter-identityInvalid f])
                                                 (when-let [f (:filter-emailInvalid filter)] [:filter-emailInvalid f])
                                                 (when-let [f (:filter-hdyInvalid filter)] [:filter-hdyInvalid f])
                                                 (when-let [f (:filter-isRk filter)] [:filter-isRk f])
                                                 (when-let [f (:filter-datenOe3 filter)] [:filter-datenOe3 f])
                                                 (when-let [f (:filter-infos filter)] [:filter-infos f])
                                                 (when-let [f (:filter-infosOe3 filter)] [:filter-infosOe3 f])
                                                 ))


   :filter-isRk                         (:filter-isRk filter)
   :filter-toe-active                   (:filter-toe-active filter)
   :identity-todo                       (:identity-todo filter)
   :orgId-todo                          (:orgId-todo filter)
   :delete-request-todo                 (:delete-request-todo filter)
   :wanado                              (when (:add-filter-wanado-show filter)
                                          (merge (:add-filter-wanado filter)
                                                 [:show true]))
   :tafel-show                          (:add-filter-tafel-show filter)

   :add-filter                          (merge {}
                                               (:add-filter-licence filter)
                                               (:add-filter-wanado filter)
                                               (:add-filter-nocat filter)
                                               (:add-filter-online filter)
                                               (:add-filter-cat filter)
                                               (:add-filter-neighbor filter)
                                               (:add-filter-tafel filter)
                                               )
   }

  )



(defn form-block-selection [!detail-search !waiting? !loaded?]

  [mui/grid
   {:item  true
    :xs    12
    :style {:marginBottom "7px"}
    }

   [mui/paper
    [mui/grid
     {:container  true
      :direction  "row"
      :alignItems "flex-start"
      :justify    "flex-start"
      :spacing    1
      :style      {:padding "5px"}
      }

     [mui/grid
      {:item true
       :lg   2
       :md   3
       :xs   6
       }
      [mui/typography "Filter Blöcke anzeigen"]
      ]
     [mui/grid
      {:item true
       :md   9
       :xs   6
       }


      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }

       [mui/radio-group {:row true :class "filterRadio"}

        [mui/form-control-label {:label   "Ort / Dienststelle" :value "dst" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-dst-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :filter-organizationDepartment nil :filter-organization nil :filter-zip nil :add-filter-dst-show %))}])}]

        [mui/form-control-label {:label   "Mitglied Status " :value "member" :placement ""
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-member-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :filter-status nil :identity-todo nil :orgId-todo nil :delete-request-todo nil
                                                                                                                           :filter-profileInvalid nil :filter-emailInvalid nil :filter-hdyInvalid nil :filter-isRk nil
                                                                                                                           :filter-identityInvalid nil :filter-infosOe3 nil :filter-infos nil :filter-datenOe3 nil
                                                                                                                           :add-filter-member-show %))}])}]

        [mui/form-control-label {:label   "Alter / Nationalität /Sprache " :value "nat" :placement "start"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-person-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :filter-age nil :filter-age-max nil :filter-nationality nil :filter-language nil :add-filter-person-show %))}])}]
        [mui/form-control-label {:label   "Ausbildung" :value "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-edu-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :filter-degree nil :filter-job-status nil :add-filter-edu-show %))}])}]
        [mui/form-control-label {:label   "Führerschein" :value "licence"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-licence-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-licence {} :add-filter-licence-show %))}])}]
        [mui/form-control-label {:label   "App" :value "has-device"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-has-device-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :has-device nil :add-filter-has-device-show %))}])}]
        ]]

      [mui/form-control
       {
        :component "fieldset"
        :fullWidth true
        }
       [mui/radio-group {:row true :class "filterRadio"}

        [mui/form-control-label {:label   "Was ich tun will" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-wanado-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-wanado {} :add-filter-wanado-show %))}])}]

        [mui/form-control-label {:label   "Katastrophenschutz Helfen" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-cat-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-cat {} :add-filter-cat-show %))}])}]

        [mui/form-control-label {:label   "Ohne Katastrophe Helfen" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-nocat-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-nocat {} :add-filter-nocat-show %))}])}]

        [mui/form-control-label {:label   "Online Helfen" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-online-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-online {} :add-filter-online-show %))}])}]
        [mui/form-control-label {:label   "Nachbarschaftshilfe" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-neighbor-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-neighbor {} :add-filter-neighbor-show %))}])}]

        [mui/form-control-label {:label   "Tafel" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-tafel-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-tafel {} :add-filter-tafel-show %))}])}]
        [mui/form-control-label {:label   "Lebensretter" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-lebensretter-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-lebensretter-show % :filter-lebensretter nil :filter-lebensretterActive nil :filter-firstResponderActive nil
                                                                                                                           :filter-lrSince-from nil :filter-lrSince-to nil :filter-lr-clearance-from nil :filter-lr-clearance-to nil :filter-lrSource nil
                                                                                                                           :filter-lebensretterHasInterventions nil :filter-lr-qualification-type [] :lr-clearanceFrom nil :lr-clearanceTo nil))}])}]
        [mui/form-control-label {:label   "Kannst Du" :placement "edu"
                                 :control (r/as-element [mui/checkbox {:checked  (get-in @!detail-search [:add-filter-canYou-show])
                                                                       :onChange (wait-do-check !waiting? !loaded? #(swap! !detail-search assoc :add-filter-canYou-show % :filter-canYou nil :filter-canYouAnswer nil))}])}]

        ]]]]]

   ])

(defn filter-form [!st searchAdd?]
  (let [!search (r/cursor !st [:search])
        !searchAddFields (r/cursor !st [:searchAddFields])
        !filter (r/cursor !st [:filter])
        !loaded? (r/cursor !st [:loaded])
        !waiting? (atom false)]
    (log/debug "Search fields !searchAddFields" (clj->js @!st))
    [mui/grid
     {:container true
      :direction "row"
      :justify   "space-around"
      :spacing   1
      }
     [mui/grid
      {:item true
       :xs   12
       }
      ]
     [form-block-selection !filter !waiting? !loaded?]

     [text-search/search-block !search !searchAddFields !waiting? !loaded? searchAdd?]

     (when (:add-filter-dst-show @!filter) [destination-filter/destination-block !filter !waiting? !loaded?])
     (when (:add-filter-member-show @!filter) [member-filter/member-block !filter !waiting? !loaded?])
     (when (:add-filter-person-show @!filter) [person-filter/person-block !filter !waiting? !loaded?])
     (when (:add-filter-edu-show @!filter) [education-filter/education-block !filter !waiting? !loaded?])
     (when (:add-filter-licence-show @!filter) [licence-filter/licence-block !filter !waiting? !loaded?])
     (when (:add-filter-has-device-show @!filter) [device-filter/device-block !filter !waiting? !loaded?])

     (when (:add-filter-wanado-show @!filter) [wanado-filter/wanado-block !filter !waiting? !loaded?])
     (when (:add-filter-cat-show @!filter) [cat-filter/cat-block !filter !waiting? !loaded?])
     (when (:add-filter-nocat-show @!filter) [nocat-filter/nocat-block !filter !waiting? !loaded?])
     (when (:add-filter-online-show @!filter) [online-filter/online-block !filter !waiting? !loaded?])
     (when (:add-filter-neighbor-show @!filter) [neighbor-filter/neighbor-block !filter !waiting? !loaded?])
     (when (:add-filter-lebensretter-show @!filter) [lebensretter-filter/lebensretter-block !filter !waiting? !loaded?])
     (when (:add-filter-canYou-show @!filter) [canYou-filter/canYou-block !filter !waiting? !loaded?])
     (when (:add-filter-tafel-show @!filter) [tafel-filter/tafel-block !filter !waiting? !loaded?])

     ])

  )